import type { IconNode } from '../types';

/**
 * @name database-arrow-up
 * @description Lucide SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkgMjJ2LTYiIC8+CiAgPHBhdGggZD0iTTIxIDEyLjUzNlY1IiAvPgogIDxwYXRoIGQ9Im0yMiAxOS0zLTMtMyAzIiAvPgogIDxwYXRoIGQ9Ik0zIDEyQTkgMyAwIDAgMCAxNC40NTcgMTQuODg2IiAvPgogIDxwYXRoIGQ9Ik0zIDVWMTlBOSAzIDAgMCAwIDEzLjMxOCAyMS45NjgiIC8+CiAgPGVsbGlwc2UgY3g9IjEyIiBjeT0iNSIgcng9IjkiIHJ5PSIzIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/database-arrow-up
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const DatabaseArrowUp: IconNode = [
  ['path', { d: 'M19 22v-6' }],
  ['path', { d: 'M21 12.536V5' }],
  ['path', { d: 'm22 19-3-3-3 3' }],
  ['path', { d: 'M3 12A9 3 0 0 0 14.457 14.886' }],
  ['path', { d: 'M3 5V19A9 3 0 0 0 13.318 21.968' }],
  ['ellipse', { cx: '12', cy: '5', rx: '9', ry: '3' }],
];

export default DatabaseArrowUp;
